export enum EligibilityResponses {
    PRE_APPROVED = 1,
    PRE_QUALIFIED = 2,
    MANUAL_APPROVED = 3,
}
